import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { TRACK_HEIGHT } from '@src/constants/timeline';

export const StyledGutterCell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: ${TRACK_HEIGHT}px;
  padding: 0 4px;
`;

export const StyledGutterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${COLOR.darkBlue};
  /* The type icon is a label, not a control — it shows the default cursor and
     no hover affordance. Only the interactive volume button gets pointer+hover. */
  cursor: ${({ $interactive = true }) =>
    $interactive ? 'pointer' : 'default'};

  &:hover {
    background: ${({ $interactive = true }) =>
      $interactive ? COLOR.indigo[8] : 'transparent'};
  }

  /* Frozen while a download/export is running: the levels are already baked into
     the file being built. */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background: transparent;
  }

  svg {
    font-size: 20px;
  }
`;
